export const getRandomUsp = (nodes) =>{
    let allUsps =  nodes.sort(() => .5 - Math.random()).slice(0,1)
    console.log(allUsps[0].usp_options)
    let randomArray = allUsps[0].usp_options.sort(() => .5 - Math.random()).slice(0,1)
    return randomArray?.[0]
}